import * as React from 'react'
import * as XState from 'xstate'
import * as XStateReact from '@xstate/react'
import Shim from 'components/Shim'

const Context = React.createContext()

export function Provider({ children }) {
    const [state, send, service] = XStateReact.useMachine(Machine)
    const context = React.useMemo(() => {
        return {
            service,
            push(notification) {
                send('PUSH', { notification })
            },
            pop() {
                send('POP')
            },
            clear() {
                send('CLEAR')
            },
        }
    }, [service, send])

    return <Context.Provider value={context}>{children}</Context.Provider>
}

// Hooks
export function useContext() {
    return React.useContext(Context)
}
function useService() {
    const { service } = useContext()

    return XStateReact.useService(service)
}

// Components
export function Toaster() {
    const [state] = useService()

    return state.context.notifications.map((notification, index) => <Toast key={index}>{notification}</Toast>)
}
function Toast({ children }) {
    return <Shim vertical>{children}</Shim>
}

// Machine
const Machine = XState.Machine(
    {
        initial: 'idle',
        context: {
            notifications: [],
        },
        states: {
            idle: {
                always: [
                    {
                        target: 'clean',
                        cond: 'isEmpty',
                    },
                    {
                        target: 'dirty',
                    },
                ],
            },
            clean: {
                entry: 'clear',
                on: {
                    PUSH: {
                        target: 'dirty',
                        actions: 'push',
                    },
                },
            },
            dirty: {
                on: {
                    CLEAR: {
                        target: 'clean',
                        actions: 'clear',
                    },
                    PUSH: {
                        target: 'dirty',
                        actions: 'push',
                    },
                    POP: {
                        target: 'idle',
                        actions: 'pop',
                    },
                },
                after: {
                    CLEAN_TIMEOUT: 'clean',
                },
            },
        },
    },
    {
        actions: {
            clear: XState.assign({
                notifications() {
                    return []
                },
            }),
            push: XState.assign({
                notifications({ notifications }, event) {
                    return [event.notification, ...notifications]
                },
            }),
            pop: XState.assign({
                notifications(context) {
                    const [first, ...notifications] = context.notifications

                    return notifications
                },
            }),
        },
        guards: {
            isEmpty(context) {
                return context.notifications.length === 0
            },
        },
        delays: {
            CLEAN_TIMEOUT: 10000,
        },
    }
)
